// Central test-id registry (extended for Hyderabad Crackers)
export * from './auth';
export * from './home';

export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home',
  combos: 'nav-combos',
  orders: 'nav-orders',
  admin: 'nav-admin',
  loginBtn: 'nav-login-btn',
  logoutBtn: 'nav-logout-btn',
  cartBadge: 'nav-cart-badge',
  wishlistBadge: 'nav-wishlist-badge',
  pincodeChip: 'nav-pincode-chip',
  searchInput: 'nav-search-input',
};

export const PINCODE = {
  modal: 'pincode-modal',
  input: 'pincode-input',
  checkBtn: 'pincode-check-btn',
  result: 'pincode-result',
};

export const PRODUCT = {
  card: (id) => `product-card-${id}`,
  addBtn: (id) => `product-add-${id}`,
  incBtn: (id) => `product-inc-${id}`,
  decBtn: (id) => `product-dec-${id}`,
  qty: (id) => `product-qty-${id}`,
  name: (id) => `product-name-${id}`,
  price: (id) => `product-price-${id}`,
  wishBtn: (id) => `product-wish-${id}`,
};

export const WISHLIST = {
  page: 'wishlist-page',
  empty: 'wishlist-empty',
  row: (id) => `wishlist-row-${id}`,
  removeBtn: (id) => `wishlist-remove-${id}`,
  addToCartBtn: (id) => `wishlist-add-${id}`,
};

export const CART = {
  stickyBar: 'sticky-cart-bar',
  viewCartBtn: 'view-cart-btn',
  page: 'cart-page',
  checkoutBtn: 'cart-checkout-btn',
  clearBtn: 'cart-clear-btn',
  itemRow: (key) => `cart-item-${key}`,
};

export const CHECKOUT = {
  page: 'checkout-page',
  nameInput: 'checkout-name',
  phoneInput: 'checkout-phone',
  line1Input: 'checkout-line1',
  line2Input: 'checkout-line2',
  cityInput: 'checkout-city',
  stateInput: 'checkout-state',
  pincodeInput: 'checkout-pincode',
  ageCheckbox: 'checkout-age-checkbox',
  placeOrderBtn: 'checkout-place-order-btn',
  successBanner: 'checkout-success-banner',
  couponInput: 'checkout-coupon-input',
  couponApplyBtn: 'checkout-coupon-apply-btn',
  couponRemoveBtn: 'checkout-coupon-remove-btn',
  slotOption: (id) => `checkout-slot-${id}`,
};

export const LOGIN = {
  page: 'login-page',
  phoneInput: 'login-phone-input',
  sendOtpBtn: 'login-send-otp-btn',
  otpInput: 'login-otp-input',
  verifyBtn: 'login-verify-btn',
  nameInput: 'login-name-input',
};

export const ORDERS = {
  page: 'orders-page',
  orderRow: (id) => `order-row-${id}`,
  reorderBtn: (id) => `order-reorder-${id}`,
};

export const ADMIN = {
  layout: 'admin-layout',
  navDashboard: 'admin-nav-dashboard',
  navProducts: 'admin-nav-products',
  navCategories: 'admin-nav-categories',
  navCombos: 'admin-nav-combos',
  navOrders: 'admin-nav-orders',
  navAnalytics: 'admin-nav-analytics',
  navRestricted: 'admin-nav-restricted',
  navCoupons: 'admin-nav-coupons',
  navBulkUpload: 'admin-nav-bulk-upload',
  navUsers: 'admin-nav-users',
  productNew: 'admin-product-new',
  productSave: 'admin-product-save',
  productDelete: (id) => `admin-product-delete-${id}`,
  productEdit: (id) => `admin-product-edit-${id}`,
  categoryNew: 'admin-category-new',
  categorySave: 'admin-category-save',
  comboNew: 'admin-combo-new',
  comboSave: 'admin-combo-save',
  orderStatusSelect: (id) => `admin-order-status-${id}`,
  orderConfirmBtn: (id) => `admin-order-confirm-${id}`,
  orderRow: (id) => `admin-order-row-${id}`,
  orderDetailPanel: 'admin-order-detail-panel',
  orderStatusChip: (s) => `admin-status-chip-${s}`,
  orderFilterNumber: 'admin-orders-filter-number',
  orderFilterPhone: 'admin-orders-filter-phone',
  orderFilterProduct: 'admin-orders-filter-product',
  orderFilterFrom: 'admin-orders-filter-from',
  orderFilterTo: 'admin-orders-filter-to',
  orderPagePrev: 'admin-orders-page-prev',
  orderPageNext: 'admin-orders-page-next',
  couponSave: 'admin-coupon-save',
  couponDelete: (id) => `admin-coupon-delete-${id}`,
  bulkFileInput: 'admin-bulk-file-input',
  bulkUploadBtn: 'admin-bulk-upload-btn',
  bulkTemplateBtn: 'admin-bulk-template-btn',
  userRow: (id) => `admin-user-row-${id}`,
  userSearch: 'admin-user-search',
};

export const HOME = {
  searchSuggestions: 'home-search-suggestions',
  searchSuggestion: (id) => `home-search-suggestion-${id}`,
};
